
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';
import { CsvModule } from '@ctrl/ngx-csv';

import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './shared/spinner.component';
import { DipartimentiComponent } from './dipartimenti/dipartimenti.component';
import { AteneiComponent } from './atenei/atenei.component';
import { AteneiDettaglioComponent } from './atenei/atenei-dettaglio/atenei-dettaglio.component';
import { DipartimentiDettaglioComponent } from './dipartimenti/dipartimenti-dettaglio/dipartimenti-dettaglio.component';
import { SettoreScientificoComponent } from './settore-scientifico/settore-scientifico.component';
import { SettoreScientificoDettaglioComponent } from './settore-scientifico/settore-scientifico-dettaglio/settore-scientifico-dettaglio.component';
import { ReferenteComponent } from './referente/referente.component';
import { ReferenteDettaglioComponent } from './referente/referente-dettaglio/referente-dettaglio.component';
import { RuoloComponent } from './ruolo/ruolo.component';
import { RuoloDettaglioComponent } from './ruolo/ruolo-dettaglio/ruolo-dettaglio.component';
import { UtentiComponent } from './utenti/utenti.component';
import { UtentiDettaglioComponent } from './utenti/utenti-dettaglio/utenti-dettaglio.component';
import { LoginComponent } from './login/login.component';
import { VerificaUtenteComponent } from './utenti/verifica-utente/verifica-utente.component';
import { PeriodiComponent } from './periodi/periodi.component';
import { PeriodiDettaglioComponent } from './periodi/periodi-dettaglio/periodi-dettaglio.component';
import { BilanciComponent } from './bilanci/bilanci.component';
import { GestisciAdesioniComponent } from './gestisci-adesioni/gestisci-adesioni.component';
import { GestisciRicevuteComponent } from './gestisci-ricevute/gestisci-ricevute.component';
import { ConfermaPagamentoComponent } from './gestisci-ricevute/conferma-pagamento/conferma-pagamento.component';
import { GeneraRicevutaComponent } from './gestisci-ricevute/genera-ricevuta/genera-ricevuta.component';
import { SociPagantiComponent } from './soci-paganti/soci-paganti.component';
import { PresidentiComponent } from './presidenti/presidenti.component';
import { PresidentiDettaglioComponent } from './presidenti/presidenti-dettaglio/presidenti-dettaglio.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { NomenuComponent } from './layouts/nomenu/nomenu.component';
import { ProfiloComponent } from './profilo/profilo.component';
import { VisualizzaDettaglioComponent } from './dashboard/visualizza-dettaglio/visualizza-dettaglio.component';
import { UgualeDipartimentoComponent } from './dashboard/uguale-dipartimento/uguale-dipartimento.component';
import { ConsultazioneBilanciComponent } from './dashboard/consultazione-bilanci/consultazione-bilanci.component';
import { ConfermaComponent } from './dashboard/conferma/conferma.component';
import { ModalitaDiPagamentoComponent } from './dashboard/modalita-di-pagamento/modalita-di-pagamento.component';
import { RiepilogoRichiestaAdesioneComponent } from './dashboard/riepilogo-richiesta-adesione/riepilogo-richiesta-adesione.component';
import { AggiungiPersonaComponent } from './dashboard/aggiungi-persona/aggiungi-persona.component';
import { RichiestaAdesioneComponent } from './dashboard/richiesta-adesione/richiesta-adesione.component';
import { MessaggioOkComponent } from './profilo/messaggio-ok/messaggio-ok.component';
import { CreaNuovoProfiloComponent } from './crea-nuovo-profilo/crea-nuovo-profilo.component';
//import { AppPreloader } from './app-routing.module';
import { AuthGuard } from './auth.guard';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccediComponent } from './accedi/accedi.component';
import { AccessoComponent } from './accesso/accesso.component';
import { RecuperaPasswordComponent } from './recupera-password/recupera-password.component';
import { ImpostapasswordperaccessoComponent } from './impostapasswordperaccesso/impostapasswordperaccesso.component';
import { NominativoEliminaComponent } from './dashboard/nominativo-elimina/nominativo-elimina.component';
import { DatiBancariComponent } from './dashboard/dati-bancari/dati-bancari.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { PaginaDiProvaComponent } from './pagina-di-prova/pagina-di-prova.component';
import { PagamentoOkComponent } from './dashboard/modalita-di-pagamento/pagamento-ok/pagamento-ok.component';
import { PagamentoAnnullatoComponent } from './dashboard/modalita-di-pagamento/pagamento-annullato/pagamento-annullato.component';
import { NuovaPasswordComponent } from './nuova-password/nuova-password.component';
import { PaginaProvaComponent } from './pagina-prova/pagina-prova.component';
import { RichiestaDiAdesioneComponent } from './dashboard/richiesta-di-adesione/richiesta-di-adesione.component';
import { VisualizzaDettaglioTabellaComponent } from './dashboard/visualizza-dettaglio-tabella/visualizza-dettaglio-tabella.component';
import { MostraNominativiComponent } from './dashboard/mostra-nominativi/mostra-nominativi.component';



import localeItIt from '@angular/common/locales/it';
registerLocaleData(localeItIt, 'it')

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppSidebarComponent,
    AteneiComponent,
    AteneiDettaglioComponent,
    DipartimentiComponent,
    DipartimentiDettaglioComponent,
    SettoreScientificoComponent,
    SettoreScientificoDettaglioComponent,
    ReferenteComponent,
    ReferenteDettaglioComponent,
    RuoloComponent,
    RuoloDettaglioComponent,
    UtentiComponent,
    UtentiDettaglioComponent,
    LoginComponent,
    VerificaUtenteComponent,
    PeriodiComponent,
    PeriodiDettaglioComponent,
    BilanciComponent,
    GestisciAdesioniComponent,
    GestisciRicevuteComponent,
    ConfermaPagamentoComponent,
    GeneraRicevutaComponent,
    SociPagantiComponent,
    PresidentiComponent,
    PresidentiDettaglioComponent,
    NomenuComponent,
    LoginComponent,
    ProfiloComponent,
    RichiestaAdesioneComponent,
    AggiungiPersonaComponent,
    RiepilogoRichiestaAdesioneComponent,
    ModalitaDiPagamentoComponent,
    NomenuComponent,
    ConfermaComponent,
    ConsultazioneBilanciComponent,
    UgualeDipartimentoComponent,
    VisualizzaDettaglioComponent,
    MessaggioOkComponent,
    CreaNuovoProfiloComponent,
    AccediComponent,
    AccessoComponent,
    RecuperaPasswordComponent,
    ImpostapasswordperaccessoComponent,
    NominativoEliminaComponent,
    DatiBancariComponent,
    PaginaDiProvaComponent,
    PagamentoOkComponent,
    PagamentoAnnullatoComponent,
    NuovaPasswordComponent,
    PaginaProvaComponent,
    RichiestaDiAdesioneComponent,
    VisualizzaDettaglioTabellaComponent,
    MostraNominativiComponent

  ],
  imports: [
    BrowserModule,
    NgxDatatableModule,
    BrowserAnimationsModule,
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    HttpClientModule,
    SharedModule, 
    RouterModule.forRoot(AppRoutes, { useHash: true }),
    CsvModule,
    NgxPayPalModule,

       ],
  entryComponents: [ //modale
    AteneiDettaglioComponent,
    DipartimentiDettaglioComponent,
    SettoreScientificoDettaglioComponent,
    ReferenteDettaglioComponent,
    RuoloDettaglioComponent,
    UtentiDettaglioComponent,
    VerificaUtenteComponent,
    PeriodiDettaglioComponent,
    ConfermaPagamentoComponent,
    GeneraRicevutaComponent,
    PresidentiDettaglioComponent,
    AggiungiPersonaComponent,
    ConfermaComponent,
    UgualeDipartimentoComponent,
    VisualizzaDettaglioComponent,
    MessaggioOkComponent,
    NominativoEliminaComponent,
    DatiBancariComponent,
    MostraNominativiComponent,


  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'it-IT' },
    /* data inizio */
  

    // { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    //  { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    //  { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    AuthGuard,


    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
